<template>
  <div style="max-width: 24rem;">
    <h1 class="h3">{{ $t('view.ResetPassword.title') }}</h1>
    <div class="_flex-row _m:bottom(4) _text:sm" style="color: var(--grey-900);">
      <span v-html="$t('view.ResetPassword.confirmCode', { email: this.email })" />
    </div>
    <ds ds="form"
      id="reset-password"
      @valid="e => isValid = e.detail"
      @submit="nextStep"
    >
      <ds ds="input-string"
        name="code"
        :label="$t('shared.label.code')"
        type="text"
        :value.sync="code"
        :validate="v => ds.vMinLength(6)(v) || ds.vAlphaNumeric(v)"
        class="_m:bottom(3)"
      />
      <ds ds="input-string"
        name="password"
        :label="$t('shared.label.password')"
        type="password"
        :value.sync="password"
        :validate="v => ds.vMinLength(8)(v) || ds.vIncludeUppercase(v)|| ds.vIncludeLowercase(v) || ds.vIncludeNumber(v)"
        class="_m:bottom(3)"
      />
      <ds ds="input-string"
        name="confirmPassword"
        :label="$t('shared.label.confirmPassword')"
        type="password"
        :value.sync="confirmPassword"
        :validate="v => ds.vOneOf([password])(v) ? $t('view.SignUp.passwordMismatch') : undefined"
        required
        class="_m:bottom(3)"
      />
      <ds ds="button"
        :label="$t('view.ResetPassword.action')"
        version="primary"
        :isLoading="isLoading"
        type="submit"
        class="_m:y(3)"
      />
      <ds ds="button"
        :label="$t('view.ResetPassword.noEmail')"
        mode="text"
        @click="resendCode"
      />
      <ds ds="button"
        id="sign-in"
        :label="$t('view.ForgotPassword.goBack')"
        @click="$router.push({ name: 'sign-in' })"
        mode="text"
        class="auth-footer"
      />
    </ds>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus';
import { mapGetters } from 'vuex';
import { LoggerService } from '@/services';
import { authHelper } from '@/mixins';
import { authGuard } from '@tokenyico/vuejs-toolkit/src/exports/mixins/guards';

export default {
  name: 'ResetPassword',
  mixins: [authHelper, authGuard({ name: 'appIndex' })],
  data: () => ({
    email: '',
    code: '',
    password: '',
    confirmPassword: '',
    isValid: false,
    isLoading: true
  }),
  computed: {
    windowTitle () {
      return this.$t('view.ResetPassword.title');
    },
    ...mapGetters({ locale: 'locale/locale' })
  },
  methods: {
    ...mapGetters({ userEmail: 'qualification/userEmail' }),
    async nextStep () {
      eventBus.$emit('isSubmitting', true);
      this.isLoading = true;
      try {
        await this.forgotPasswordConfirm({
          username: this.email,
          code: this.code,
          password: this.confirmPassword
        });
        LoggerService.success(this.$t('view.ResetPassword.successMessage'));
        this.$router.push({ name: 'sign-in' });
      } catch (error) {
        LoggerService.error(error);
      }
      this.isLoading = false;
      eventBus.$emit('isSubmitting', false);
    },
    async resendCode () {
      eventBus.$emit('isSubmitting', true);
      try {
        await this.forgotPassword({
          username: this.email,
          clientMetadata: {
            language: this.locale
          }
        });
        LoggerService.success(this.$t('view.ResetPassword.checkEmail'));
      } catch (error) {
        LoggerService.error(error);
      }
      eventBus.$emit('isSubmitting', false);
    }
  },
  async mounted () {
    this.isLoading = true;

    const query = new URLSearchParams(location.search);

    if (query.get('email')) {
      this.email = query.get('email');
    } else if (this.userEmail()) {
      this.email = this.userEmail();
    }

    if (!this.email) {
      this.$router.push({ name: 'forgot-password' });
    }

    this.isLoading = false;
  }
};
</script>
